import React from 'react';
import { css } from 'emotion';
import cloneDeep from "lodash/cloneDeep";
import { set } from "dot-prop-immutable";
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import { getLocale } from '@utils/util';
import { Upload as DesignUpload, Button, message } from '@whalecloud/fdx';

const left = css({ textAlign: 'left' });
const Upload = props => {
  const messages = getLocale();

  const { updateElement, element, nameSpace } = props;
  const { data: { formSettings = {}, formItemSettings = {}, settings = {}, className = '' } = {} } = element;
  const { buttonText = '', listType, download, showError, successMessage = messages['PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS_DEFAULT'], errorMessage = messages['PAGEBUIDER_SETTINGS_UPLOAD_ERROR_DEFAULT'], failMessage = messages['PAGEBUIDER_SETTINGS_UPLOAD_FAILD_DEFAULT'] } = formItemSettings;
  const errorSizeMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_ERROR_SIZE"];

  const { horizontalAlign = 'left', width } = settings;
  const eventProps = makeEventProps(element.data.events, nameSpace);
  const { onChange = null, ...otherEventPros} = eventProps;
  const typeList = formItemSettings?.accept?.split(',') || [];
  const fileSize = formItemSettings?.fileSize;
  const rule = formSettings.rules ? formSettings.rules[0] : {};

  const handleChange = info => {
    let fileList = [...info.fileList];
    fileList = fileList.map(file => {
      if (info.file.status === 'done') {
        // eslint-disable-next-line no-template-curly-in-string
        file.url = download.replace('${id}', file.response[0][formItemSettings.fileIdName]);
      }
      return file;
    });
    if (info.file.status === 'done') {
      message.success(successMessage);
      const renderModel = (window.g_app._store.getState())[nameSpace] || {};
      if (!renderModel) {
        return false;
      }
      const { eventJs, form, childForm, fetch, macro } = renderModel;
      const ctx = {
        form,
        childForm,
        macro,
        fetch,
        events: eventJs
      };
      onChange && onChange(info, ctx);
    }
    if (info.file.status === 'error') {
      message.error(failMessage);
    }

    const newElement = set(element, 'data.formItemSettings.fileList', cloneDeep(fileList.filter(item=>item.status!=='error')));
    updateElement({
      element: newElement,
    }, nameSpace);
  };

  //文件类型校验
  const checkType = (file, typeList) => {
    return new Promise(function (resolve, reject) {
      let res = false;
      if ((typeList.length === 0) || typeList.includes('*')) {
        res = true
      } else {
        typeList.forEach(type => {
          if (type === file.type) {
            res = true
          }
          if (type === 'image/*' && file.type.includes('image')) {
            res = true
          }
          if (type === 'video/*' && file.type.includes('video')) {
            res = true
          }
          if (type === 'audio/*' && file.type.includes('audio')) {
            res = true
          }
        });
      }
      if (res) {
        resolve()
      } else {
        message.error(errorMessage)
        reject()
      }
    })
  }

   //文件大小校验
   const checkSize = (file) => {
    return new Promise(function(resolve, reject) {
      let res = true;
      if( fileSize ) {
        const isLt2M = file.size / 1024 / 1024 < fileSize;
        res = isLt2M;
      }
      if (res) {
        resolve();
      } else {
        message.error( `${errorSizeMessage} ${fileSize}MB`);
        reject();
      }
    });
  };

  const normFile = (e: any) => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return (
      e &&
      (showError
        ? e.fileList
        : e.fileList.filter((item) => item.status !== "error"))
    );
  };

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-upload', left)}
            {...formSettings}
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[{...rule, validator: (rules, value, callback) => {
              if(rules.required && (!value || !value.length)) {
                callback(rules.message || '请选择文件')
              }else if(value && value.some(item => item.status === 'uploading')){
                callback('文件正在上传')
              }else{
                callback()
              }
            }}]}
          >
            <DesignUpload
              {...formItemSettings}
              className={className}
              style={{ width: width.value }}
              beforeUpload={(file, fileList) => {
                return Promise.all([
                  checkType(file, [...typeList]),checkSize(file)
                ])
              }}
              onChange={handleChange}
              {...otherEventPros}
            >
              {listType !== 'picture-card' ? <Button icon="folder">{buttonText}</Button> : null}
            </DesignUpload>
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default Upload;

